import React from 'react'
import { Box, Flex, PseudoBox, Text } from '@chakra-ui/core'
import { Edit, Tag as TagIcon, Trash2 } from 'lucide-react'
import { ITag, RootState } from '../../../constants/interfaces'
import { useSelector } from 'react-redux'
import { PreviewAvatarsList } from 'components/CommonComponents/PreviewList'
import { Users, Folder } from 'lucide-react'
import { ActionMenu } from '../commonUI/ActionMenu'
import { TAG_TYPE } from './TagModal'
import { isRtlSelector } from 'redux/selectors/general'
import useLocaleText from 'components/useLocaleText'

interface TagCardProps {
  tag: ITag
  isLoading: boolean
  onEdit: (sk: string) => void
  onDelete: (sk: string) => void
}

export const TagCard: React.FC<TagCardProps> = ({ tag, onEdit, onDelete, isLoading }) => {
  const isRtl = useSelector(isRtlSelector)
  const { retailUsersObject, groups: retailGroupsObject } = useSelector((state: RootState) => state.config.config)
  const { tag_color, sk, groups, users, tag_type } = tag

  const t_users = useLocaleText('users')
  const t_groups = useLocaleText('groups')

  const tagUsers = users ? users.map((user) => retailUsersObject?.[user]) : []
  const tagGroups = groups ? groups.map((group) => retailGroupsObject?.[group]) : []

  const tagColor = tag_color

  const optionsList =
    tag_type === TAG_TYPE.SYSTEM || tag_type === undefined
      ? [{ label: 'admin_edit_action', icon: <Edit size={16} />, onClick: () => onEdit(sk) }]
      : [
          { label: 'admin_edit_action', icon: <Edit size={16} />, onClick: () => onEdit(sk) },
          { label: 'admin_delete_action', icon: <Trash2 size={16} />, onClick: () => onDelete(sk), color: 'red.500' },
        ]

  return (
    <PseudoBox
      borderWidth="1px"
      borderRadius="15px"
      overflow="hidden"
      _hover={{ boxShadow: 'md' }}
      transition="all 0.3s ease"
      display="flex"
      position="relative"
    >
      <Box width="6px" height="100%" backgroundColor={tagColor} />

      <Box px={5} py={2} flex="1" background={`linear-gradient(to right, ${tagColor}15, transparent)`}>
        <Flex alignItems="center" style={{ columnGap: '5px' }}>
          <TagIcon color={tagColor} size={16} />
          <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'md', lg: 'xl' }}>
            {tag.name}
          </Text>
        </Flex>

        <Box mt={4} mb={2}>
          <PreviewAvatarsList
            icon={Users}
            label={t_users}
            items={tagUsers.map((user) => ({
              name: `${user?.first_name} ${user?.last_name || ''}`,
              profile_img_url: user?.profile_img_url,
            }))}
            defaultValue="-"
          />

          <PreviewAvatarsList
            icon={Folder}
            label={t_groups}
            items={tagGroups.map((group) => ({
              name: group?.name || '',
            }))}
            isGroup
            defaultValue="-"
          />
        </Box>
      </Box>
      <ActionMenu
        isLoading={isLoading}
        tooltipText="Edit Tag"
        optionsList={optionsList}
        triggerProps={{ top: '10px', right: isRtl ? 'unset' : '10px', left: isRtl ? '10px' : 'unset' }}
      />
    </PseudoBox>
  )
}
